export default {
  Query: {
    fields: {},
  },
};
